import React from "react";
import "./LoginScreen.css";
import SignUpScreen from "./SignUpScreen";
import Nav from "../Nav";
import { useSelector } from "react-redux";
import { selectUser } from "../features/userSlice";
import HomeScreen from "./HomeScreen";

const LoginScreen = () => {
  const user = useSelector(selectUser);

  return user ? (
    <HomeScreen />
  ) : (
    <div className="loginScreen">
      <Nav />
      <div className="loginScreen__background">
        <div className="loginScreen__gradient" />
      </div>
      <div className="loginScreen__body">
        <SignUpScreen />
      </div>
    </div>
  );
};

export default LoginScreen;
